import { tabToName } from "@utils/utils";

import { Button, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { DialogModalTabType, useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

export const DialogTab = () => {
  const { selectedDialogTab, setSelectedDialogTab } = useVideoAnalytics();

  const tabs: DialogModalTabType[] = ["Raw Data"];

  return (
    <div className={` no-scrollbar overflow-x-scroll border-gray-200`}>
      <TabNavigation
        shrink
        tabs={tabs.map((tab) => ({
          current: selectedDialogTab === tab,
          type: "component",
          name: tab,
          Component: (
            <Button
              text={<div className="w-full flex font-normal flex-row justify-center gap-2">{tabToName(tab)}</div>}
              appearance="text"
              className={`hover:text-primary ${selectedDialogTab === tab ? "text-limestone-900" : "text-text-secondary"}`}
              onClick={() => setSelectedDialogTab(tab)}
            />
          ),
        }))}
      />
    </div>
  );
};
